import { get, post } from "./common/http";
import { BASE_URL } from "./common/const";
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";

export const GetExpenseDetail = (params: any) =>
     GET_ENC(`${BASE_URL}/api/Expense/GetDetail?` + params, null);

export const GetExpenseList = (params: any) =>
     GET_ENC(`${BASE_URL}/api/Expense/GetList?` + params, null);

export const CreateExpense = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Expense/Create`, data);

export const DeleteExpense = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Expense/Delete`, data);

export const UpdateExpense = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Expense/Update`, data);

export const GetExpenseNumber = (params: any) =>
     GET_ENC(`${BASE_URL}/api/Expense/GetExpenseNumber?` + params, null);

export const GetExpenseSummaryByVehicle = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Expense/GetExpenseSummaryByVehicle?` + params, null);



export const GetExpenseSummaryByCategory = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Expense/GetExpenseSummaryByCategory?` + params, null);

export const GetExpenseSummaryByLedgerAccount = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Expense/GetExpenseSummaryByLedgerAccount?` + params, null);


